import React from "react";
import { Body } from "../../../Common/Typography";
import {
  ButtonWrapper,
  MenuOptionWrapper,
  SubtitleDiv,
  TextWrapper,
} from "./__styles__/Operations";

const MenuOption = ({
  title,
  helperText,
  actionsDropdown,
}: {
  title: string;
  helperText?: string;
  actionsDropdown: React.ReactNode;
}) => {
  return (
    <MenuOptionWrapper>
      <TextWrapper>
        <SubtitleDiv>
          <Body type="emphasis" size="large">
            {title}
          </Body>
        </SubtitleDiv>
        {helperText && (
          <Body type="regular" size="default" color="contentSecondary">
            {helperText}
          </Body>
        )}
      </TextWrapper>
      <ButtonWrapper>{actionsDropdown}</ButtonWrapper>
    </MenuOptionWrapper>
  );
};

export default MenuOption;
